/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse } from "models";
import { BrandPayload } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { statementAction } from "./statementSlice";
import statementApi from "api/statementApi";

function* getStatementList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      statementApi.getStatementList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data) {
      yield put(statementAction.getStatementSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(statementAction.getStatementFailed(errorData));
  }
}

export default function* statementSaga() {
  yield takeLatest(statementAction.getStatement, getStatementList);
}
